module.exports = __webpack_public_path__ + "static/img/1.bbae89f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/1/sp/1.png
// module id = RfN1
// module chunks = 0